export default __webpack_public_path__ + "static/media/desktop2x.019b1677.png";